import {implementsTKeys, strEnum} from "../../types";
import {ITCIMetrics, ITCIMetricsStatus} from "../tci";

export const MetricsAppType = strEnum(["flogo", "bw", "node", "scribe"]);
export type MetricsAppType = keyof typeof MetricsAppType;

export const MetricsScopeType = strEnum(["org", "app"]);
export type MetricsScopeType = keyof typeof MetricsScopeType;

export const MetricsAppStatusType = strEnum(["good", "error", "stopped", "warning"]);
export type MetricsAppStatusType = keyof typeof MetricsAppStatusType;

export const MetricsExecutionsStatusType = strEnum(["success", "failure"]);
export type MetricsExecutionsStatusType = keyof typeof MetricsExecutionsStatusType;

export const MetricsInstancesStatusType = strEnum(["max", "min", "avg"]);
export type MetricsInstancesStatusType = keyof typeof MetricsInstancesStatusType;

// export const MetricsType = strEnum(["tci_apps", "tci_apps_instances", "tci_apps_total_executions", "tci_apps_top_executions"]);
// export type MetricsType = keyof typeof MetricsType;

/**
 * interface IMetricsLabels
 */
export interface IMetricsLabels {
    app_id?: string;
    instance_id?: string;
    subscription_id?: string;
    app_type?: MetricsAppType;
    status?: MetricsInstancesStatusType | MetricsExecutionsStatusType | MetricsAppStatusType;
}


// /**
//  * interface IMetricsAppStatus
//  */
// export interface IMetricsAppStatus {
//     value: number;
//     labels: IMetricsLabels;
// }
//
// /**
//  * interface IMetricsAppStatus
//  */
// export interface IMetricsAppStatusRange {
//     values: (number | string)[];
//     labels: IMetricsLabels;
// }


export interface IMetricsStatus {
    value?: string | number;
    values?: (string | number)[];
    labels: IMetricsLabels;
}

// /**
//  * interface IMetricsLabeledApp
//  */
// export interface IMetricsLabeledApp {
//     tci_app_executions: IMetricsAppStatus;
//     tci_app_uptime: IMetricsAppStatus;
//     tci_app_instances_cpu: IMetricsAppStatus;
//     tci_app_instances_memory: IMetricsAppStatus;
//     tci_app_instances_cpu_range: IMetricsAppStatusRange;
//     tci_app_instances_memory_range: IMetricsAppStatusRange;
//     tci_app_instances_success_exes_range: IMetricsAppStatusRange;
//     tci_app_instances_failure_exes_range: IMetricsAppStatusRange;
// }


export const MetricsLabelType = strEnum([
    "tci_app_executions",
    "tci_app_uptime",
    "tci_app_instances_cpu",
    "tci_app_instances_memory",
    "tci_app_instances_cpu_range",
    "tci_app_instances_memory_range",
    "tci_app_instances_success_exes_range",
    "tci_app_instances_failure_exes_range",
    "tci_apps_total_executions",
    "tci_apps_top_executions",
    "tci_apps",
    "tci_apps_instances",
]);

export type MetricsLabelType = keyof typeof MetricsLabelType;


/**
 * interface IMetricsLabel
 */
export interface IMetricsLabel {
    [labelType: string]: IMetricsStatus[];
}

// /**
//  * interface IMetricsLabeledApp
//  */
// export interface IMetricsLabeledOrg {
//     tci_apps_total_executions: IMetricsAppStatus;
//     tci_apps_top_executions: IMetricsAppStatus;
//     tci_apps: IMetricsAppStatus[];
//     tci_apps_instances: IMetricsAppStatus[];
// }


/**
 *
 */
export class MetricsHelper {
    /**
     *
     * @param x
     */
    public static isAppMetrics<T extends ITCIMetrics>(x: T): boolean {
        return implementsTKeys<T>(x, ["labeledAppMetrics"]);
    }

    /**
     *
     * @param x
     */
    public static isOrgMetrics<T extends ITCIMetrics>(x: T): boolean {
        return implementsTKeys<T>(x, ["labeledOrgMetrics"]);
    }

    /**
     *
     * @param x
     */
    public static isRange<T extends ITCIMetricsStatus>(x: T): boolean {
        return implementsTKeys<T>(x, ["values"]);
    }
}

/**
 * GET /metricsserver-1/v1/metrics with "metricsType=app" param
 * GET /metricsserver-1/v1/metrics with "metricsType=org" param
 * "Query metrics data for the app" or "org"
 * interface IMetricsApp
 */
export interface IMetrics {
    labeledOrgMetrics?: IMetricsLabel;
    labeledAppMetrics?: IMetricsLabel;
}

// /**
//  * GET /metricsserver-1/v1/metrics with "metricsType=org" param
//  * "Query metrics data for the org"
//  * interface IMetricsOrg
//  */
// export interface IMetricsOrg {
//     labeledOrgMetrics: IMetricsLabeledOrg;
// }


// For metrics registration
export interface IMetricsRegistration {
    appId: string;
    total: number;
}
